module.exports = __webpack_public_path__ + "img/edge_divers_services_medicaux.4563f136.svg";